module.exports = __webpack_public_path__ + "static/media/eatimage2.5bf03243.png";